var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGround = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 0.75
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M4 8.435 12.5 4 21 8.435"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M5.417 7.696V21h14.166V7.696"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M5.417 17.458h13.458"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.792 21 2.125-3.542M9.667 21l2.125-3.542M7.542 21l2.125-3.542M5.417 21l2.125-3.542M13.917 21l2.125-3.542M16.042 21l2.125-3.542M18.167 21l1.416-2.48"
})))));
export default SvgGround;